import { useNavigate } from "react-router";
import { Button } from "@/components/ui/Button";
import { Shield, ArrowLeft } from "lucide-react";

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background px-4">
      <div className="flex h-20 w-20 items-center justify-center rounded-2xl bg-muted">
        <Shield className="h-10 w-10 text-muted-foreground" />
      </div>
      <h1 className="mt-6 text-7xl font-bold text-gradient">404</h1>
      <p className="mt-4 text-xl font-semibold text-foreground">Page not found</p>
      <p className="mt-2 max-w-sm text-center text-sm text-muted-foreground">
        The page you're looking for doesn't exist or has been moved to another location.
      </p>
      <Button className="mt-8 gap-2" onClick={() => navigate("/dashboard")}>
        <ArrowLeft className="h-4 w-4" />
        Back to Dashboard
      </Button>
    </div>
  );
}
